<template>
  <v-container fluid>
    <h2 class="py-0">COCINA</h2>
    <v-divider class="mb-3"></v-divider>
    <v-row>
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title>{{ $t('delivery.states.NEW') }}</v-card-title>
          <order-flow-table ref="NEW" state="NEW" :action-prev="false"
                            @orderUpdateNext="$refs.PREPARING.fetchOrders()" :show-icons="false"
                            :disable-headers="['contact.name', 'payment.confirmed','totalAmount','location.address','delivery.distance','deliveryUser.username']"
          />

        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title>{{ $t('delivery.states.PREPARING') }}</v-card-title>
          <order-flow-table ref="PREPARING" state="PREPARING"
                            @orderUpdatePrev="$refs.NEW.fetchOrders()" :show-icons="false" :action-next="false  "
                            :disable-headers="['contact.name', 'payment.confirmed','totalAmount','location.address','delivery.distance','deliveryUser.username']"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OrderFlowTable from "@/modules/delivery/components-core/business/OrderFlowTable/OrderFlowTable";


export default {
  name: "OrderFlowKitchenPage",
  components: {OrderFlowTable},
  mounted() {
    this.$store.dispatch('fetchCategories')
  }
}
</script>

<style scoped>

</style>
